import React, { Dispatch, SetStateAction } from 'react'
import { Tabs, TabsBar, Tab, Spacer, theme, TabPanels, TabPanel } from '@mtsdengi/ui-kit'
import { TTabs } from '@shared/types'

type TTabsSwitcherProps = {
  tabs: TTabs['tabs']
  currentTab: string
  setTab: Dispatch<SetStateAction<string>>
}

export const TabsSwitcher = ({ tabs, currentTab, setTab }: TTabsSwitcherProps) => (
  <Tabs tab={currentTab} variant="violet" font="compact">
    <TabsBar size="lg" onChange={(nextTab) => setTab(nextTab)}>
      {tabs.map(({ id, label }) => (
        <Tab size="lg" key={id} label={label} tab={String(id)} />
      ))}
    </TabsBar>
    <Spacer samespace space={theme.spacings.md} />
    <TabPanels domMounted>
      {tabs.map(({ label }) => (
        <TabPanel key={label} tab={currentTab} />
      ))}
    </TabPanels>
  </Tabs>
)
